namespace Rio.Enums {
    export enum EViewType {
        Unlimited = 0,
        LimitedPerContent = 1
    }
    Serenity.Decorators.registerEnumType(EViewType, 'Rio.Enums.EViewType');
}
